module.exports = __webpack_public_path__ + "img/symbol_12.71e3ebb7.png";